import { getAudioBySentence, getChunkAudioBySentence } from '../../../../modules/apis/student/conversation'
import { CONVERSATION_ROLE } from '../../../../modules/vars'
import { decodeChunk } from '../../../common/audio/decode'
import SoundController, { AudioCtx } from '../../../common/audio/play/soundchunked'
import { AppendableArrayBuffer } from '../../../common/buffer'

const PLAY_LISTENER_KEY = '__playListenerRegistered__' as const

const playResolvers = new Map()
let isPlayListenerRegistered = false

function registerPlayListener() {
  if (typeof window === 'undefined' || isPlayListenerRegistered) return

  if ((window as any)[PLAY_LISTENER_KEY]) return
  ;(window as any)[PLAY_LISTENER_KEY] = true

  isPlayListenerRegistered = true

  const handleNativeMessage = (e: MessageEvent) => {
    let msg: any
    try {
      msg = JSON.parse(e.data)
    } catch {
      return
    }
    if (msg.type === 'played' && playResolvers.has(msg.idx)) {
      playResolvers.get(msg.idx)!(msg.success)
      playResolvers.delete(msg.idx)
    }
  }

  window.addEventListener('message', handleNativeMessage, false)
  // Android 구형 WebView: document에
  document.addEventListener('message', handleNativeMessage, false)

  // // 브라우저 런타임일 때만 한 번 실행
  // if (typeof window !== 'undefined') {
  //   window.addEventListener('message', (e) => {
  //     let msg: any
  //     try {
  //       msg = JSON.parse(e.data)
  //     } catch {
  //       return
  //     }

  //     if (msg.type === 'played' && playResolvers.has(msg.idx)) {
  //       playResolvers.get(msg.idx)!(msg.success)
  //       playResolvers.delete(msg.idx)
  //     }
  //   })
  // }
}
registerPlayListener()

export const splitResponse = (text: string) => {
  const splittable = ['.', '!', '?']
  let splitted = [text || '']
  for (const s of splittable) {
    const temp = []
    for (const t of splitted) {
      const segs = t.split(s)
      for (let i = 0; i < segs.length; i++) {
        temp.push(segs[i] + (i < segs.length - 1 ? s : ''))
      }
    }
    splitted = temp.map((i) => i.trim()).filter((i) => i)
  }
  return splitted
}

export async function ttsProvider(
  sound: SoundController,
  updateMessage: (any) => void,
  setCurrentPlaying: (v: number) => void,
  setShowErrorModal: (any) => void,
  voice: any,
  ttsInstruction: any
) {
  const urls: Blob[] = []

  let xmlMode: boolean | null = null

  let audioPromise = Promise.resolve(true)

  let fetchPromise = Promise.resolve()

  const pl = 0
  const lines: string[] = []

  // ▶️ xmlBuffer와 plainBuffer는 스트리밍으로 들어오는 데이터를 저장해서 tts에 보내기에 적합한 형태로 변환하기 위한 buffer
  let xmlBuffer = ''
  let plainBuffer = ''

  let processingContent = false // <content> 이후부터 처리 시작

  // ▶️ 지금까지 처리한 문장 수
  let processedLinesCount = 0

  const processingNarrative = false
  const narrativeProcessed = false

  // ▶️ 문장이 의미있게 종료 돼는지 판단.
  const isComplete = (s: string) => /[.!?]$/.test(s)

  // ▶️ xml 인지 평가.
  function isXmlChunk(text: string): boolean {
    return text.includes('<')
  }

  const MIN_DETECT_LENGTH = 5

  const ctx = await new AudioCtx().refresh()

  const buffers: ArrayBuffer[] = []

  const newLine = async (line: string, idx: number, instruction: string, isApp: boolean) => {
    // const audioStream = await getAudioBySentence(line, voice, instruction)

    const buf = await getChunkAudioBySentence(line, voice, instruction)
    function arrayBufferToBase64(buffer: ArrayBuffer): string {
      let binary = ''
      const bytes = new Uint8Array(buffer)
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      return window.btoa(binary)
    }
    const base64 = arrayBufferToBase64(buf)

    if (isApp) {
      const playedPromise = new Promise((resolve) => {
        playResolvers.set(idx, resolve)

        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'playBuffer',
            idx,
            payload: base64,
          })
        )

        //사실, 구지 음성이 다 재생될때까지 기다릴 필요도 없긴해서 그냥 바로 resolve true하자.
        resolve(true)
      })

      // 5) RN에서 재생 완료 신호가 오면 handler 호출
      const success = await playedPromise

      if (success) {
        return buf
      } else {
        return null
      }
    }

    return buf
    // if (success) {
    //   return buf
    // } else {
    //   return null
    // }
  }

  const line = async (line: string, idx: number, handler?: any, instruction?: any) => {
    console.log(`voice~ 🟢-----------> ${line}`)
    const audioStream = await getAudioBySentence(line, voice, instruction)

    if (!audioStream) {
      // alert('s')
      setShowErrorModal(true)
      return
    }

    audioPromise = audioPromise.then(async (prevComplete) => {
      if (!prevComplete) {
        const array = new AppendableArrayBuffer()
        // eslint-disable-next-line no-constant-condition
        while (true) {
          const { value, done } = await audioStream.read()
          if (value) array.append(value)
          if (done) break
        }
        const [_, intBuf] = await decodeChunk(ctx, array.uint8Array())
        const buf = ctx.wav(intBuf)
        buffers.push(buf)
        urls.push(new Blob([buf], { type: 'audio/mpeg' }))
        return false
      }
      const [complete, [buf]] = await sound.play([audioStream as any], () => {
        if (handler) handler()
        // setCurrentPlaying(idx)
      })

      console.log('🟡🟡🟡before buffers~ ->', buf)
      buffers.push(buf)

      console.log('🔴buffers =====>', buffers)
      urls.push(new Blob([buf], { type: 'audio/mpeg' }))
      return complete
    })

    // audioPromise = audioPromise.then(async (prevComplete) => {
    //   if (!prevComplete) {
    //     const array = new AppendableArrayBuffer()
    //     // eslint-disable-next-line no-constant-condition
    //     while (true) {
    //       const { value, done } = await audioStream.read()
    //       if (value) array.append(value)
    //       if (done) break
    //     }
    //     const [_, intBuf] = await decodeChunk(ctx, array.uint8Array())
    //     const buf = ctx.wav(intBuf)
    //     buffers.push(buf)
    //     urls.push(new Blob([buf], { type: 'audio/mpeg' }))
    //     return false
    //   }

    //   const [complete, [buf]] = await sound.play([audioStream as any], () => {
    //     if (handler) handler()
    //     // setCurrentPlaying(idx)
    //   })

    //   buffers.push(buf)
    //   urls.push(new Blob([buf], { type: 'audio/mpeg' }))
    //   return complete
    // })
  }

  // Next Version (compatible with xml and text)
  const update = (chunk: string, handler?: any) => {
    xmlBuffer += chunk

    if (xmlMode === null && xmlBuffer.length >= MIN_DETECT_LENGTH) {
      xmlMode = isXmlChunk(xmlBuffer)
      console.log(`▶️ Mode set to ${xmlMode ? 'XML' : 'Plain text'}`)
    }

    if (xmlMode === null) {
      console.log('⏳ 모드 판단 전, 대기 중…')
      return fetchPromise
    }

    if (!xmlMode) {
      plainBuffer += chunk

      // 아 스트리밍으로 받는게 아니라.. 문장은 계속 안생기겠구나.
      //line은 전역 변수 입니다.
      // lines = splitResponse(plainBuffer)

      // 한 문단을 통째로 합시다. 혹은 나눠서 해도 되고 뭐 크게 상관은 없을 듯.
      const sentences = [plainBuffer]
      // 한 문단을 통째로.
      // const sentences = [plainBuffer]

      if (sentences.length > processedLinesCount) {
        //극단적으로 하나만 하자.

        line(sentences[0], 0, handler)

        // for (let i = processedLinesCount; i < sentences.length; i++) {
        //   fetchPromise = fetchPromise.then(() => line(sentences[i], i, handler))
        // }

        processedLinesCount = sentences.length
      }

      return fetchPromise
    }

    const START_TAG = '<content>'
    const END_TAG = '</content>'
    console.log('xml mode ✅✅✅')

    // ▶️ 1) 아직 <content>를 못 만났으면, 버퍼에서 찾아서 그 뒤만 남기고 리턴
    // fetchPromise를 리턴하는 것은 return false 같은거라고 생각하면 됨. (실행하지 않음)
    if (!processingContent) {
      const idx = xmlBuffer.indexOf(START_TAG)
      if (idx === -1) {
        console.log('in xml, not found start tag.')
        return fetchPromise
      }

      // <content> 발견: 그 뒤부터 실제 본문 시작
      xmlBuffer = xmlBuffer.slice(idx + START_TAG.length)
      console.log('🟢 Start Tag Found')
      processingContent = true
      processedLinesCount = 0
    }

    // ▶️ 2) 이제 본문 처리: </content>가 있으면 그 전까지만 잘라내고
    //    아니면 지금까지 모인 전체를 처리 대상으로 삼습니다.
    let textToProcess: string
    const endIdx = xmlBuffer.indexOf(END_TAG)
    if (endIdx >= 0) {
      textToProcess = xmlBuffer.slice(0, endIdx)
      // 이후에 다시 같은 XML이 들어올 수 있으니 버퍼 초기화
      xmlBuffer = ''
      processingContent = false
    } else {
      textToProcess = xmlBuffer
    }

    // ▶️ 3) 문장 단위로 분할
    // 이때 textToProcess는 </content>가 나올때까지 계속 업데이트 됨.

    // 분리하지말고.. 한번에 가자.
    // lines = splitResponse(textToProcess)

    // console.log('text to process ======>', textToProcess)
    // // → 이제 lines 에는 오직 <content>…</content> 사이의 텍스트만 들어있음.
    // // pl = lines.length - 1

    // const sentences = lines.filter(isComplete)

    const sentences = [textToProcess]

    // ▶️ 4) 새로 생긴 문장들만 스트리밍
    if (sentences.length > processedLinesCount) {
      // for (let i = processedLinesCount; i < sentences.length; i++) {
      //   fetchPromise = fetchPromise.then(() => line(sentences[i], i, handler))
      // }
      // processedLinesCount = sentences.length
      line(sentences[0], 0, handler)

      // for (let i = processedLinesCount; i < sentences.length; i++) {
      //   fetchPromise = fetchPromise.then(() => line(sentences[i], i, handler))
      // }

      processedLinesCount = sentences.length
    }

    return fetchPromise
  }

  // const updateNarrativeVersion = (chunk: string, handler?: any) => {
  //   console.log('🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴')
  //   xmlBuffer += chunk

  //   if (xmlMode === null && xmlBuffer.length >= MIN_DETECT_LENGTH) {
  //     xmlMode = isXmlChunk(xmlBuffer)
  //     console.log(`▶️ Mode set to ${xmlMode ? 'XML' : 'Plain text'}`)
  //   }

  //   if (xmlMode === null) {
  //     console.log('⏳ 모드 판단 전, 대기 중…')
  //     return fetchPromise
  //   }

  //   if (!xmlMode) {
  //     plainBuffer += chunk

  //     //line은 전역 변수 입니다.
  //     lines = splitResponse(plainBuffer)
  //     const sentences = lines.filter(isComplete)

  //     if (sentences.length > processedLinesCount) {
  //       for (let i = processedLinesCount; i < sentences.length; i++) {
  //         fetchPromise = fetchPromise.then(() => line(sentences[i], i, handler))
  //       }
  //       processedLinesCount = sentences.length
  //     }

  //     return fetchPromise
  //   }

  //   const NARRATIVE_START = '<narrative>'
  //   const NARRATIVE_END = '</narrative>'

  //   const START_TAG = '<content>'
  //   const END_TAG = '</content>'

  //   let narrativeContent = '' // 여기 담을 거예요

  //   // XML mode
  //   // ▶️ narrative 뽑기
  //   if (!narrativeProcessed) {
  //     console.log('narrative not procsseed 🧩🧩🧩🧩🧩')
  //     const startIdx = xmlBuffer.indexOf(NARRATIVE_START)
  //     const endIdx = xmlBuffer.indexOf(NARRATIVE_END)

  //     // narrative 태그가 전부 버퍼에 도착했으면
  //     if (startIdx >= 0 && endIdx > startIdx) {
  //       // 태그 사이 전체 텍스트를 저장
  //       narrativeContent = xmlBuffer.slice(startIdx + NARRATIVE_START.length, endIdx)
  //       narrativeProcessed = true

  //       // narrative 부분을 버퍼에서 제거
  //       xmlBuffer = xmlBuffer.slice(endIdx + NARRATIVE_END.length)
  //     } else {
  //       // 아직 narrative 전부 안 왔으면 다음 chunk 대기
  //       return fetchPromise
  //     }
  //   }

  //   console.log('????????????????????????????????🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴🔴')
  //   console.log('▶️▶️▶️▶️ narrative ====>', narrativeContent)
  //   // ▶️ 1) 아직 <content>를 못 만났으면, 버퍼에서 찾아서 그 뒤만 남기고 리턴
  //   // fetchPromise를 리턴하는 것은 return false 같은거라고 생각하면 됨. (실행하지 않음)
  //   if (!processingContent) {
  //     const idx = xmlBuffer.indexOf(START_TAG)
  //     if (idx === -1) {
  //       console.log('in xml, not found start tag.')
  //       return fetchPromise
  //     }

  //     // <content> 발견: 그 뒤부터 실제 본문 시작
  //     xmlBuffer = xmlBuffer.slice(idx + START_TAG.length)
  //     console.log('🟢 Start Tag Found')
  //     processingContent = true
  //     processedLinesCount = 0
  //   }

  //   // ▶️ 2) 이제 본문 처리: </content>가 있으면 그 전까지만 잘라내고
  //   //    아니면 지금까지 모인 전체를 처리 대상으로 삼습니다.
  //   let textToProcess: string
  //   const endIdx = xmlBuffer.indexOf(END_TAG)
  //   if (endIdx >= 0) {
  //     textToProcess = xmlBuffer.slice(0, endIdx)
  //     // 이후에 다시 같은 XML이 들어올 수 있으니 버퍼 초기화
  //     xmlBuffer = ''
  //     processingContent = false
  //   } else {
  //     textToProcess = xmlBuffer
  //   }

  //   // ▶️ 3) 문장 단위로 분할
  //   // 이때 textToProcess는 </content>가 나올때까지 계속 업데이트 됨.
  //   lines = splitResponse(textToProcess)
  //   // → 이제 lines 에는 오직 <content>…</content> 사이의 텍스트만 들어있음.
  //   // pl = lines.length - 1

  //   const sentences = lines.filter(isComplete)

  //   // ▶️ 4) 새로 생긴 문장들만 스트리밍
  //   if (sentences.length > processedLinesCount) {
  //     for (let i = processedLinesCount; i < sentences.length; i++) {
  //       console.log('🙏🙏🙏🙏🙏🙏🙏🙏🙏🙏🙏🙏🙏🙏🙏🙏narrativecontent-=------------------->', narrativeContent)
  //       fetchPromise = fetchPromise.then(() => line(sentences[i], i, handler, narrativeContent || ''))
  //     }
  //     processedLinesCount = sentences.length
  //   }

  //   return fetchPromise
  // }

  const finalize = async () => {
    if (processedLinesCount) {
      for (let i = processedLinesCount; i < lines.length; i++) {
        fetchPromise = fetchPromise.then(() => line(lines[i], i))
      }
    }
    await fetchPromise
    await audioPromise
    ctx.destroy()

    console.log('🔴🔴buffers =====>', buffers)

    updateMessage({ role: CONVERSATION_ROLE.ASSISTANT, audio_files: urls })

    return buffers.filter((i) => i)
  }

  return { update, finalize, newLine }
}
